<template>
  <div class="barra-acoes">
    <div class="filtros-busca">
      <button class="btn-filtros" @click="mostrarFiltros = true">
        <img src="@/assets/icons/filter.png" alt="filtros" width="20" height="20" />
        Filtros
      </button>
      <FiltrosNoticias v-if="popupFiltroHandler('noticia')" :filtrosIniciais="props.filtrosIniciais"
        @fechar="mostrarFiltros = false" @aplicarFiltros="handlerAplicarFiltros" />
      <FiltroAtividade v-if="popupFiltroHandler('atividade')" :filtrosIniciais="props.filtrosIniciais"
        @fechar="mostrarFiltros = false" @aplicarFiltros="handlerAplicarFiltros" />
      <FiltrosTarefas v-if="popupFiltroHandler('tarefa')" @fechar="mostrarFiltros = false"
        @aplicarFiltros="handlerAplicarFiltros" />
      <FiltrosAcoes v-if="popupFiltroHandler('acao')" :filtrosIniciais="props.filtrosIniciais"
        @fechar="mostrarFiltros = false" @aplicarFiltros="handlerAplicarFiltros" />
      <FiltrosVagas v-if="popupFiltroHandler('vaga')" :filtrosIniciais="ultimosFiltrosVagas"
        @fechar="mostrarFiltros = false" @aplicarFiltros="handlerAplicarFiltros" />
      <FiltrosParcerias v-if="popupFiltroHandler('parceria')" :filtrosIniciais="props.filtrosIniciais"
        @fechar="mostrarFiltros = false" @aplicarFiltros="handlerAplicarFiltros" />
      <ModalAcoesCurricularizadas :mostrar="modalCurricularizadasVisivel"
        @fechar="modalCurricularizadasVisivel = false" />
      <SearchInput @pesquisar="enviarTermoBusca" />
      <slot name="after-search"></slot>
    </div>
    <div class="acoes-direita">
      <!-- Select de Unidade no topo direito (apenas em Notícias Gerais) -->
      <div v-if="props.nomeTela === 'noticia' && !viaAcao" class="select-unidade-wrapper">
        <FiltroSelect :items="unidadesNoticias" :msg-todos="'PREX'" v-model="unidadeSelecionada"
          :tamanho="'pequeno'" :uppercase="true" @change="onSelecionarUnidade" />
      </div>

      <!-- Botão Listar Vagas de Ações Curricularizadas (exibido apenas na tela GERAL de vagas) -->
      <button v-if="props.nomeTela === 'vaga' && !viaAcao" class="btn-toggle-curricularizadas"
        @click="abrirCurricularizadas" title="Listar Ações Curriculares de Extensão">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
          <path d="M6 12v5c3 3 9 3 12 0v-5" />
        </svg>
        <span>Listar Ações Curriculares de Extensão</span>
      </button>

      <!-- Modal para Usuário Não Logado -->
      <div v-if="mostrarModalLogin" class="overlay" @click.self="mostrarModalLogin = false">
        <div class="modal-login-card">
          <div class="modal-header">
            <span class="modal-label">Atenção</span>
          </div>
          <div class="modal-login-body">
            <div class="modal-login-content">
              <i class="fa-sharp fa-solid fa-circle-exclamation fa-3x"
                style="color: var(--roxo-primario); margin-bottom: 8px;"></i>


              <p>
                Para entrar em contato com os coordenadores desta ação, por favor
                faça login.
              </p>
            </div>
            <div class="modal-rodape">
              <button class="btn-modal-ok" @click="mostrarModalLogin = false">
                Voltar
              </button>
              <button class="btn-modal-entrar" @click="irParaLogin">
                Entrar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Toggle Aceitando Curricularização (exibido quando vier por AÇÃO e tiver acoesCurricularizadas não vazio - visível a todos, alterável apenas por Coordenadores) -->
      <div v-if="props.nomeTela === 'vaga' && viaAcao && temAcoesCurricularizadas" class="toggle-curricularizacao-acao"
        :class="{
          aceitando: aceitandoCurricularizacao,
          readonly: !props.isCoordenador,
        }" @click="toggleAceiteCurricularizacao" :title="aceitandoCurricularizacao
          ? 'Vagas curriculares disponíveis'
          : 'Vagas curriculares indisponíveis'
          ">
        <span class="status-indicator"></span>
        <span class="toggle-label">
          {{
            aceitandoCurricularizacao
              ? "Vagas curriculares disponíveis"
              : "Vagas curriculares indisponíveis"
          }}
        </span>
        <div class="switch-track">
          <div class="switch-thumb"></div>
        </div>
      </div>
      <button v-if="
        props.isCoordenador &&
        (props.nomeTela === 'parceria' ||
          $route.path.includes(props.nomeTela))
      " @click="
        props.nomeTela === 'parceria'
          ? abrirFormularioParceria()
          : abriModal()
        " class="btn-publicar">
        Cadastrar {{ props.nomeTela }}
      </button>
    </div>
  </div>
  <ModalAcoesCurricularizadas :mostrar="modalCurricularizadasVisivel" @fechar="modalCurricularizadasVisivel = false" />

  <EscolhaFormulario v-if="mostrarModalFormularios" @fecharModal="fecharModalFormularios"
    @formularioExterno="acessarFormularioExterno" @formularioInterno="acessarFormularioInterno" />
</template>
<script setup>
import { ref, watch, computed } from "vue";
import { useRoute } from "vue-router";
import FiltrosNoticias from "@/components/noticias/FiltrosNoticias.vue";
import FiltroAtividade from "@/components/atividades/FiltroAtividade.vue";
import FiltrosTarefas from "@/components/tarefas/FiltrosTarefas.vue";
import FiltrosAcoes from "@/components/acoes/FiltrosAcoes.vue";
import FiltrosParcerias from "@/components/modals/FiltrosParcerias.vue";
import EscolhaFormulario from "@/components/modals/EscolhaFormulario.vue";
import router from "@/router";
import FiltrosVagas from "@/components/vagas/FiltrosVagas.vue";
import ModalAcoesCurricularizadas from "@/components/acoes/ModalAcoesCurricularizadas.vue";
import acaoService from "@/service/acaoService";
import unidadesService from "@/service/unidadesService";
import { formatarEnum } from "@/utils/FormatarEntradas";
import { onMounted } from "vue";
import { useAuthStore } from "@/stores/auth";
import { storeToRefs } from "pinia";
import userInfos from "@/utils/userInfos";
import SearchInput from "../layout/SearchInput.vue";
import FiltroSelect from "./FiltroSelect.vue";

const props = defineProps({
  nomeTela: String,
  isCoordenador: Boolean,
  filtrosIniciais: {
    type: Object,
    default: () => ({}),
  },
  termoBuscaInicial: {
    type: String,
    default: "",
  },
});

const route = useRoute();
const viaAcao = computed(
  () => !!route.params.id || (route.path && route.path.includes("/acao/"))
);
const acaoIdAtual = computed(() => route.params.id);

const authStore = useAuthStore();
const { isAutenticado, estaRenovando } = storeToRefs(authStore);
const isLogado = computed(() => isAutenticado.value || estaRenovando.value);

const mostrarFiltros = ref(false);
const modalCurricularizadasVisivel = ref(false);
const mostrarModalLogin = ref(false);

function abrirCurricularizadas() {
  modalCurricularizadasVisivel.value = true;
  const user = userInfos.getUserInfos();
  if (!user && !isLogado.value) {
    mostrarModalLogin.value = true;
  }
}

function irParaLogin() {
  router.push("/login");
}
const aceitandoCurricularizacao = ref(true);
const temAcoesCurricularizadas = ref(false);
const unidades = ref([]);
const unidadesNoticias = computed(() => {
  return [
    { id: "TODAS", nome: "TODAS AS UNIDADES", label: "TODAS AS UNIDADES" },
    ...unidades.value,
  ];
});
const unidadeSelecionada = ref(
  props.filtrosIniciais?.unidadeId || route.query.unidadeId || ""
);
const mostrarModalFormularios = ref(false);

function abrirFormularioParceria() {
  if (!props.isCoordenador) return;

  mostrarModalFormularios.value = true;
}

function fecharModalFormularios() {
  mostrarModalFormularios.value = false;
}

function acessarFormularioExterno() {
  mostrarModalFormularios.value = false;

  router.push({
    name: "formulario-parceria-externa",
    params: {
      id: route.params.id,
    },
  });
}

function acessarFormularioInterno() {
  mostrarModalFormularios.value = false;

  router.push({
    name: "formulario-parceria-interna",
    params: {
      id: route.params.id,
    },
  });
}

watch(
  () => [props.filtrosIniciais?.unidadeId, route.query.unidadeId],
  ([newProp, newQuery]) => {
    unidadeSelecionada.value = newProp || newQuery || "";
  }
);

onMounted(async () => {
  try {
    const lista = await unidadesService.getAllUnidades(0, 1000);
    if (lista && Array.isArray(lista)) {
      unidades.value = lista;
      unidades.value = unidades.value.map((unidade) => {
        return { ...unidade, label: unidade.nome.toUpperCase() }
      })
    }
  } catch (e) {
    console.error("Erro ao carregar unidades em FiltrosComponent:", e);
  }
});

function onSelecionarUnidade() {
  const query = { ...route.query };
  if (unidadeSelecionada.value) {
    query.unidadeId = unidadeSelecionada.value;
  } else {
    delete query.unidadeId;
  }
  query.page = 0;
  router.replace({ query });
}

watch(
  acaoIdAtual,
  async (newId) => {
    if (newId) {
      try {
        const res = await acaoService.getAcoesById(newId);
        const acao = res?.data || res;
        if (acao) {
          // Verificar se o campo acoesCurricularizadas não está vazio
          const campoCurricular =
            acao.acoesCurricularizadas ??
            acao.acaoCurricularizada ??
            acao.acoesCurricularizada;
          if (Array.isArray(campoCurricular)) {
            temAcoesCurricularizadas.value = campoCurricular.length > 0;
          } else if (typeof campoCurricular === "boolean") {
            temAcoesCurricularizadas.value = campoCurricular;
          } else if (
            campoCurricular !== undefined &&
            campoCurricular !== null
          ) {
            temAcoesCurricularizadas.value = Boolean(campoCurricular);
          } else {
            temAcoesCurricularizadas.value = false;
          }

          const valorCurricular =
            acao.curricularizada ??
            acao.isCurricularizada ??
            acao.curricularizacao;
          if (valorCurricular !== undefined && valorCurricular !== null) {
            aceitandoCurricularizacao.value = Boolean(valorCurricular);
            localStorage.setItem(
              `aceitandoCurricularizacao_${newId}`,
              aceitandoCurricularizacao.value.toString()
            );
            return;
          }
        }
      } catch (error) {
        console.error(
          "Erro ao verificar campo curricularizada da ação:",
          error
        );
      }

      const salvo = localStorage.getItem(`aceitandoCurricularizacao_${newId}`);
      if (salvo !== null) {
        aceitandoCurricularizacao.value = salvo === "true";
      }
    } else {
      temAcoesCurricularizadas.value = false;
    }
  },
  { immediate: true }
);

async function toggleAceiteCurricularizacao() {
  if (!props.isCoordenador) return;
  const novoEstado = !aceitandoCurricularizacao.value;

  // Atualiza localmente/otimisticamente
  aceitandoCurricularizacao.value = novoEstado;

  if (acaoIdAtual.value) {
    try {
      await acaoService.atualizarCurricularizada(acaoIdAtual.value, novoEstado);
      localStorage.setItem(
        `aceitandoCurricularizacao_${acaoIdAtual.value}`,
        novoEstado.toString()
      );
    } catch (error) {
      console.error(
        "Erro ao atualizar status de curricularização no backend:",
        error
      );
      // Reverte estado em caso de erro na requisição
      aceitandoCurricularizacao.value = !novoEstado;
    }
  }
}

const emits = defineEmits(["aplicarFiltros", "pesquisar"]);

function abriModal() {
  router.push((name = `cadastrar-${props.nomeTela}`));
}

function popupFiltroHandler(nomeComponente) {
  return props.nomeTela === nomeComponente && mostrarFiltros.value;
}

const ultimosFiltrosVagas = ref({});

function handlerAplicarFiltros(filtros) {
  if (props.nomeTela === "vaga") {
    ultimosFiltrosVagas.value = { ...filtros };
  }
  emits("aplicarFiltros", filtros);
}

function enviarTermoBusca(termo) {
  emits("pesquisar", termo);
}
</script>
<style scoped>
.barra-acoes {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin: 1.5rem 0rem;
  width: 100%;
}

.filtros-busca {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

/* .btn-filtros removido daqui: já existe idêntico em
   src/assets/css/utils/_utilities.css (era uma cópia exata,
   redundante, e escondia o estilo global por causa da
   especificidade do CSS "scoped" do Vue). */

.btn-filtros {
  background: var(--branco);
  border-radius: 5px;
  height: 39px;
  padding: 6px 14px;
  font-size: 0.85rem;
  cursor: pointer;
  color: var(--roxo-primario);
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  flex-shrink: 0;
  box-sizing: border-box;
  line-height: 1.2;
}

.btn-filtros img {
  filter: invert(17%) sepia(74%) saturate(2506%) hue-rotate(247deg) brightness(68%) contrast(104%);
}

.acoes-direita {
  display: flex;
  align-items: center;
  gap: 16px;
}

.select-unidade-wrapper {
  display: flex;
  align-items: center;
}

.select-unidade-topo {
  max-width: 190px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 6px 28px 6px 12px;
  border: 1px solid var(--roxo-primario);
  border-radius: 5px;
  font-size: 0.85rem;
  color: var(--roxo-primario);
  background: var(--branco);
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: 500;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23563578' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.select-unidade-topo:focus {
  border-color: var(--roxo-medio);
  box-shadow: 0 0 0 2px hsla(258, 53%, 28%, 0.15);
}

.select-unidade-topo.selecionado {
  border-color: var(--roxo-primario) !important;
  background-color: var(--roxo-superficie) !important;
  color: var(--roxo-primario) !important;
  font-weight: 600 !important;
  box-shadow: 0 0 0 3px hsla(258, 53%, 28%, 0.08) !important;
}

.btn-toggle-curricularizadas {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 39px;
  background: var(--branco, var(--branco));
  border: 1px solid var(--roxo-primario);
  color: var(--roxo-primario);
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
}

.btn-toggle-curricularizadas:hover {
  background: var(--roxo-superficie);
}

.btn-toggle-curricularizadas.ativo {
  background: var(--roxo-superficie);
  border-color: var(--roxo-claro, var(--roxo-medio));
  color: var(--roxo-claro, var(--roxo-medio));
  font-weight: 600;
  box-shadow: 0 2px 6px hsla(258, 46%, 46%, 0.15);
}

.toggle-curricularizacao-acao {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: var(--branco);
  border: 1px solid var(--cinza-claro);
  border-radius: 20px;
  padding: 5px 14px;
  cursor: pointer;
  user-select: none;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.toggle-curricularizacao-acao:hover {
  box-shadow: 0 2px 8px hsla(0, 0%, 0%, 0.08);
}

.toggle-curricularizacao-acao.readonly {
  cursor: default;
}

.toggle-curricularizacao-acao.readonly:hover {
  box-shadow: none;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--cinza-medio);
  transition:
    background-color 0.25s ease,
    box-shadow 0.25s ease;
}

.toggle-curricularizacao-acao.aceitando {
  background: var(--roxo-superficie);
  border-color: var(--roxo-claro, var(--roxo-medio));
}

.toggle-curricularizacao-acao.aceitando .status-indicator {
  background-color: var(--roxo-claro, var(--roxo-medio));
  box-shadow: 0 0 6px hsla(258, 46%, 46%, 0.6);
}

.toggle-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--cinza-medio);
  transition: color 0.25s ease;
}

.toggle-curricularizacao-acao.aceitando .toggle-label {
  color: var(--roxo-primario);
}

.switch-track {
  width: 32px;
  height: 18px;
  background-color: var(--cinza-claro);
  border-radius: 10px;
  position: relative;
  transition: background-color 0.25s ease;
}

.toggle-curricularizacao-acao.aceitando .switch-track {
  background-color: var(--roxo-claro, var(--roxo-medio));
}

.switch-thumb {
  width: 14px;
  height: 14px;
  background-color: var(--branco);
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px hsla(0, 0%, 0%, 0.2);
}

.toggle-curricularizacao-acao.aceitando .switch-thumb {
  transform: translateX(14px);
}

.btn-publicar {
  /* cor de fundo/texto removida daqui: herda de .btn-publicar
     em _utilities.css (var(--roxo-medio)). Antes esta regra
     sobrepunha o global com var(--roxo-primario), causando uma
     cor diferente do resto do site para este botão específico. */
  border: none;
  border-radius: 5px;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
}

.btn-publicar:hover {
  opacity: 0.9;
}


.modal-login-card {
  border-radius: 16px;
  width: 100%;
  overflow: hidden;
  max-width: 420px;


}

.modal-header {
  justify-content: center;
}

.modal-login-content {
  background-color: var(--branco);
  text-align: center;
  padding: 1rem;
  padding-bottom: 0rem;
  width: 100%;
}

.modal-login-content p {
  font-size: 0.9rem !important;
  font-weight: 400 !important;
  color: var(--preto) !important;


}

.modal-login-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-icon-wrapper {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--roxo-superficie);
  color: var(--roxo-primario);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-login-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: var(--cinza-escuro);
  margin: 0;
}

.modal-login-body p {
  font-size: 14px;
  color: var(--cinza-escuro);
  line-height: 1.5;
  margin: 0;
}


.btn-modal-ok {
  padding: 8px 20px;
  border-radius: 8px;
  background: var(--roxo-primario);
  color: var(--branco);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-modal-ok:hover {
  background: var(--roxo-medio);
}

.btn-modal-entrar {
  padding: 8px 24px;
  border-radius: 8px;
  border: none;
  background: var(--roxo-primario);
  color: var(--branco);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-modal-entrar:hover {
  background: var(--roxo-medio);
}

@media (max-width: 600px) {
  .filtros-busca {
    display: flex;
    width: 100%;
    align-items: end;
    justify-content: end;
    flex-direction: column-reverse;
  }

}
</style>
